export default __webpack_public_path__ + "static/media/card-bg-img.48ec48db.svg";